/* ============================================================
   BOOPII — global.js
   Vanilla JS. Progressive enhancement — the store works without
   it; this layer adds the drawer, AJAX cart, variant picker,
   gallery, sticky ATC and filtering niceties.
   V9: shared panel fixes + AJAX cart drawer (Section Rendering API).
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.Boopii || { routes: {}, strings: {}, cartType: 'drawer' };
  CFG.routes = CFG.routes || {};
  CFG.strings = CFG.strings || {};
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Locale-aware cart endpoints ---------- */
  function jsEndpoint(url, fallback) {
    url = url || fallback;
    return /\.js$/.test(url) ? url : url + '.js';
  }
  var CART_URL = CFG.routes.cart || '/cart';
  var CART_ADD_JS = jsEndpoint(CFG.routes.cart_add, '/cart/add');
  var CART_CHANGE_JS = jsEndpoint(CFG.routes.cart_change, '/cart/change');
  var CART_SECTION = 'cart-drawer';

  /* ---------- Overlay / focus utilities ---------- */
  var PANEL_SEL = '[data-panel], [data-menu-drawer], [data-search-modal], [data-cart-drawer]';
  var lastFocused = null;
  var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function openPanels() { return $$('.is-open').filter(function (el) { return el.matches(PANEL_SEL); }); }
  function anyPanelOpen() { return openPanels().length > 0; }

  function lockScroll(on) {
    document.documentElement.classList.toggle('scroll-lock', !!on);
    document.body.classList.toggle('scroll-lock', !!on);
  }

  function trapFocus(container, e) {
    var f = $$(focusableSel, container).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!container.contains(document.activeElement)) { first.focus(); e.preventDefault(); return; }
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  function openPanel(panel, returnFocusTo) {
    if (!panel) return;
    openPanels().forEach(function (p) { if (p !== panel) closePanel(p, true); });
    if (panel.classList.contains('is-open')) return;
    lastFocused = returnFocusTo || document.activeElement;
    if (panel._hideTimer) { window.clearTimeout(panel._hideTimer); panel._hideTimer = null; }
    if (panel.hasAttribute('hidden')) {
      panel._restoreHidden = true;
      panel.removeAttribute('hidden');
      void panel.offsetWidth; // let the slide-in transition run
    }
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    panel._boopiiOpen = true;
    lockScroll(true);
    var focusTarget = panel.querySelector('[data-autofocus]') || panel.querySelector(focusableSel);
    window.setTimeout(function () { if (focusTarget) focusTarget.focus(); }, 60);
    document.removeEventListener('keydown', panelKeydown);
    document.addEventListener('keydown', panelKeydown);
  }

  function closePanel(panel, silent) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel._boopiiOpen = false;
    if (panel._restoreHidden) {
      // Re-hide after the exit transition so a closed panel never blocks clicks.
      panel._hideTimer = window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.setAttribute('hidden', '');
        panel._hideTimer = null;
      }, 360);
    }
    var stillOpen = anyPanelOpen();
    lockScroll(stillOpen);
    if (!stillOpen) document.removeEventListener('keydown', panelKeydown);
    if (!silent && lastFocused && document.contains(lastFocused)) {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function panelKeydown(e) {
    var open = openPanels()[0];
    if (!open) return;
    if (e.key === 'Escape') { closePanel(open); }
    else if (e.key === 'Tab') { trapFocus(open, e); }
  }

  /* ---------- Wire open/close triggers via delegation ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var panel = $('[data-panel="' + opener.getAttribute('data-open') + '"]');
      if (panel) { e.preventDefault(); openPanel(panel); }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var p = closer.closest(PANEL_SEL);
      if (p) { e.preventDefault(); closePanel(p); }
      return;
    }
    // Click on overlay backdrop
    if (e.target.matches('[data-overlay]')) {
      var parent = e.target.closest(PANEL_SEL);
      if (parent) closePanel(parent);
    }
  });

  /* ---------- Legacy explicit hooks (menu / search) ---------- */
  function bindToggle(openAttr, panelSel) {
    $$('[' + openAttr + ']').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel($(panelSel));
      });
    });
  }
  bindToggle('data-menu-open',   '[data-menu-drawer]');
  bindToggle('data-search-open', '[data-search-modal]');
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel($('[data-menu-drawer]')); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel($('[data-search-modal]')); }); });

  /* ---------- Quantity steppers (product cards + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var down = e.target.closest('[data-qty-down]');
    var up   = e.target.closest('[data-qty-up]');
    if (!down && !up) return;
    var wrap = (down || up).closest('.qty-selector');
    var input = wrap ? wrap.querySelector('input') : null;
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    val = up ? val + 1 : val - 1;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     CART DRAWER (AJAX)
     ============================================================ */
  function drawerEl() { return $('[data-cart-drawer]'); }
  function drawerEnabled() { return CFG.cartType === 'drawer' && !!drawerEl() && !!window.fetch; }
  function onCartPage() { return !!$('[data-cart-page]'); }

  function readJSON(response) {
    return response.text().then(function (text) {
      var body = null;
      try { body = text ? JSON.parse(text) : {}; } catch (err) { body = { description: 'Something went wrong. Please try again.' }; }
      if (!response.ok) throw body;
      return body;
    });
  }

  function errorMessage(err) {
    if (err && typeof err.description === 'string' && err.description) return err.description;
    if (err && typeof err.message === 'string' && err.message && err.message !== 'Cart Error') return err.message;
    return 'Sorry, something went wrong. Please try again.';
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
      el.classList.toggle('is-empty', count < 1);
    });
  }

  function announce(text) {
    var live = $('[data-cart-live]');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 80);
  }

  // Quantities the customer has asked for but which haven't been sent yet.
  var pendingQty = {};

  function renderDrawer(html) {
    var drawer = drawerEl();
    if (!drawer || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-content]');
    var current = drawer.querySelector('[data-cart-drawer-content]');
    if (!fresh || !current) return false;

    var active = document.activeElement;
    var focusKey = active && current.contains(active) ? active.getAttribute('data-focus-key') : null;
    var hadFocus = active && current.contains(active);

    current.innerHTML = fresh.innerHTML;
    var count = parseInt(fresh.getAttribute('data-cart-count-value'), 10);
    if (!isNaN(count)) {
      current.setAttribute('data-cart-count-value', count);
      updateCartCount(count);
    }

    // Keep any not-yet-sent quantity changes visible.
    Object.keys(pendingQty).forEach(function (key) {
      var line = lineByKey(key);
      var input = line && line.querySelector('[data-cart-qty]');
      if (input) input.value = pendingQty[key].qty;
    });

    if (hadFocus) {
      var target = null;
      if (focusKey) {
        $$('[data-focus-key]', current).some(function (el) {
          if (el.getAttribute('data-focus-key') === focusKey) { target = el; return true; }
          return false;
        });
      }
      target = target || current.querySelector('[data-focus-key="close"]');
      if (target) target.focus();
    }
    return true;
  }

  function renderFromSections(sections) {
    return !!(sections && sections[CART_SECTION] && renderDrawer(sections[CART_SECTION]));
  }

  function lineByKey(key) {
    var drawer = drawerEl();
    if (!drawer) return null;
    var found = null;
    $$('[data-cart-item]', drawer).some(function (el) {
      if (el.getAttribute('data-key') === key) { found = el; return true; }
      return false;
    });
    return found;
  }

  function showDrawerError(message) {
    var region = $('[data-cart-error]', drawerEl() || document);
    if (region) { region.textContent = message; region.hidden = false; }
    else { announce(message); }
  }

  function setDrawerBusy(on) {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.classList.toggle('is-updating', !!on);
    var content = $('[data-cart-drawer-content]', drawer);
    if (content) content.setAttribute('aria-busy', on ? 'true' : 'false');
    $$('[data-cart-checkout]', drawer).forEach(function (b) { b.disabled = !!on; });
  }

  function refreshDrawer() {
    var sep = CART_URL.indexOf('?') === -1 ? '?' : '&';
    return fetch(CART_URL + sep + 'sections=' + CART_SECTION, { headers: { 'Accept': 'application/json' } })
      .then(readJSON)
      .then(function (data) { renderFromSections(data); });
  }

  function summary() {
    var drawer = drawerEl();
    var subtotal = drawer && $('[data-cart-subtotal]', drawer);
    var ship = drawer && $('.cart-ship__text', drawer);
    var parts = ['Cart updated.'];
    if (subtotal) parts.push('Subtotal ' + subtotal.textContent.trim() + '.');
    if (ship) parts.push(ship.textContent.trim());
    if (drawer && !$('[data-cart-item]', drawer)) parts = ['Your cart is empty.'];
    return parts.join(' ');
  }

  // Serialise cart requests so responses can never arrive out of order.
  var cartQueue = Promise.resolve();
  function enqueue(task) {
    var run = cartQueue.then(task, task);
    cartQueue = run.catch(function () {});
    return run;
  }

  function changeLine(key, quantity) {
    return enqueue(function () {
      setDrawerBusy(true);
      return fetch(CART_CHANGE_JS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: CART_SECTION, sections_url: window.location.pathname })
      })
        .then(readJSON)
        .then(function (cart) {
          if (!renderFromSections(cart.sections)) return refreshDrawer();
        })
        .then(function () { announce(summary()); })
        .catch(function (err) {
          return refreshDrawer()
            .catch(function () {})
            .then(function () { showDrawerError(errorMessage(err)); });
        })
        .then(function () { setDrawerBusy(false); });
    });
  }

  function scheduleChange(key, quantity) {
    if (pendingQty[key]) window.clearTimeout(pendingQty[key].timer);
    pendingQty[key] = {
      qty: quantity,
      timer: window.setTimeout(function () {
        var q = pendingQty[key].qty;
        delete pendingQty[key];
        changeLine(key, q);
      }, 350)
    };
  }

  /* Drawer: +/− buttons (debounced so fast taps send one request) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty-change]');
    if (!btn || !btn.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var line = btn.closest('[data-cart-item]');
    var input = line && line.querySelector('[data-cart-qty]');
    if (!input) return;
    var key = line.getAttribute('data-key');
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-cart-qty-change'), 10);
    if (next < 1) next = 1; // removing is done with the Remove button
    input.value = next;
    var down = line.querySelector('[data-cart-qty-change="-1"]');
    if (down) { if (next <= 1) down.setAttribute('aria-disabled', 'true'); else down.removeAttribute('aria-disabled'); }
    scheduleChange(key, next);
  });

  /* Drawer: Remove */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    var key = rm.getAttribute('data-key');
    if (rm.closest('[data-cart-drawer]')) {
      if (pendingQty[key]) { window.clearTimeout(pendingQty[key].timer); delete pendingQty[key]; }
      var line = rm.closest('[data-cart-item]');
      if (line) line.classList.add('is-removing');
      changeLine(key, 0);
      return;
    }
    // Cart page fallback: set to 0 and submit the normal form.
    var page = rm.closest('[data-cart-page]');
    if (page) {
      var input = null;
      $$('[data-cart-qty]', page).some(function (el) {
        if (el.getAttribute('data-key') === key) { input = el; return true; }
        return false;
      });
      var f = page.querySelector('[data-cart-page-form]');
      if (input && f) {
        input.value = 0;
        if (f.requestSubmit) f.requestSubmit(f.querySelector('[name="update"]')); else f.submit();
      }
    }
  });

  /* Typed quantities (drawer = AJAX, cart page = normal form submit) */
  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-cart-qty]');
    if (!qtyInput) return;
    var page = qtyInput.closest('[data-cart-page]');
    if (page) {
      var f = page.querySelector('[data-cart-page-form]');
      if (f) f.requestSubmit ? f.requestSubmit(f.querySelector('[name="update"]')) : f.submit();
      return;
    }
    if (qtyInput.closest('[data-cart-drawer]')) {
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var key = qtyInput.getAttribute('data-key');
      if (pendingQty[key]) { window.clearTimeout(pendingQty[key].timer); delete pendingQty[key]; }
      changeLine(key, qty);
    }
  });

  /* Enter in a drawer quantity box commits the value */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var qtyInput = e.target.closest && e.target.closest('[data-cart-drawer] [data-cart-qty]');
    if (qtyInput) { e.preventDefault(); qtyInput.blur(); }
  });

  /* Header cart icon */
  $$('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!drawerEnabled() || onCartPage()) return; // on /cart just reload the page
      e.preventDefault();
      openPanel(drawerEl(), btn);
      enqueue(function () { return refreshDrawer().catch(function () {}); });
    });
  });

  /* ---------- Add to cart → drawer ---------- */
  function isAddForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(\.js)?(\?|#|$)/.test(action);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !isAddForm(form)) return;
    if (!drawerEnabled() || !window.FormData) return; // cart page mode: normal Shopify submit

    e.preventDefault();
    if (form._boopiiBusy) return; // prevent double submission
    form._boopiiBusy = true;

    var returnFocus = document.activeElement;
    var btn = (e.submitter && e.submitter.form === form) ? e.submitter
      : form.querySelector('[name="add"], [data-add-button], [type="submit"]');
    var textEl = btn ? (btn.querySelector('[data-add-button-text]') || (btn.children.length ? null : btn)) : null;
    var prevText = textEl ? textEl.textContent : '';
    var prevDisabled = btn ? btn.disabled : false;
    var errorEl = form.querySelector('[data-form-error], [data-safe-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }

    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (textEl) textEl.textContent = CFG.strings.adding || 'Adding…';
    }

    function restoreButton() {
      form._boopiiBusy = false;
      if (!btn) return;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = prevDisabled;
      if (textEl) textEl.textContent = prevText;
    }

    var data = new FormData(form);
    data.append('sections', CART_SECTION);
    data.append('sections_url', window.location.pathname);

    enqueue(function () {
      return fetch(CART_ADD_JS, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(readJSON)
        .then(function (res) {
          if (!renderFromSections(res.sections)) return refreshDrawer();
        })
        .then(function () {
          restoreButton();
          var focusBack = (returnFocus && returnFocus !== document.body && document.contains(returnFocus)) ? returnFocus : btn;
          openPanel(drawerEl(), focusBack);
          announce('Added to cart. ' + summary().replace('Cart updated. ', ''));
        })
        .catch(function (err) {
          restoreButton();
          var msg = errorMessage(err);
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else { window.alert(msg); }
        });
    });
  });

  /* ---------- Product media gallery ---------- */
  $$('[data-product-gallery]').forEach(function (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-media-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-media-thumb');
      $$('.product-gallery__slide', gallery).forEach(function (s) {
        var match = s.getAttribute('data-media-id') === id;
        s.hidden = !match;
        s.classList.toggle('is-active', match);
      });
      $$('[data-media-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceWrap = root.querySelector('[data-price-wrapper]');
    var addBtn = root.querySelector('[data-add-button]');
    var addText = root.querySelector('[data-add-button-text]');
    var section = root.closest('[data-product-section]');
    var stickyPrice = section ? section.querySelector('[data-sticky-price]') : null;

    function selectedOptions() {
      return $$('[data-option-input]:checked', root).map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); }
        if (addText) addText.textContent = CFG.strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      // price
      var priceHtml = v.compare_at_price && v.compare_at_price > v.price
        ? '<div class="price price--on-sale"><span class="price__sale">' + money(v.price) + '</span> <s class="price__compare">' + money(v.compare_at_price) + '</s></div>'
        : '<div class="price"><span class="price__regular">' + money(v.price) + '</span></div>';
      if (priceWrap) priceWrap.innerHTML = priceHtml;
      if (stickyPrice) stickyPrice.innerHTML = priceHtml;
      // availability
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); if (addText) addText.textContent = CFG.strings.addToCart || 'Add to cart'; }
        else { addBtn.setAttribute('disabled', 'disabled'); if (addText) addText.textContent = CFG.strings.soldOut || 'Sold out'; }
      }
      // update URL param for shareability
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-input]')) update();
    });
  });

  /* ---------- Mobile sticky ATC ---------- */
  var sticky = $('[data-sticky-atc]');
  if (sticky) {
    var mainAdd = $('[data-add-button]');
    var stickyAddBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyAddBtn && mainAdd) {
      stickyAddBtn.addEventListener('click', function () {
        var form = mainAdd.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit(mainAdd) : mainAdd.click();
      });
    }
    var buyRegion = $('.product-form__wrap') || $('.product-info');
    var onScroll = function () {
      if (!buyRegion) return;
      var r = buyRegion.getBoundingClientRect();
      var below = r.bottom < 0;
      sticky.hidden = !below;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Collection facets ---------- */
  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    // auto-apply on change (checkbox/price/sort)
    facetForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select, input[type="number"]')) {
        if (e.target.type === 'number') return; // let price use Apply / Enter
        facetForm.requestSubmit ? facetForm.requestSubmit() : facetForm.submit();
      }
    });
  }
  // sort select outside the form (shares form attr) still triggers submit
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var f = document.getElementById(sortSel.getAttribute('form')) || facetForm;
      if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
    });
  }
  // facet drawer toggle (mobile)
  $$('[data-facet-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var facets = $('[data-facets]');
      if (!facets) return;
      var open = facets.classList.toggle('is-open');
      document.body.classList.toggle('scroll-lock', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

})();